import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { randomString } from 'src/app/_core/_function/randomid';
import { DataService } from 'src/app/_services/data.service';
// import { OfferFlatComponent } from '../offer-flat/offer-flat.component';
import { Title } from '@angular/platform-browser';
import { GoogleAnalyticsService } from 'src/app/_services/google-analytics.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss']
})



export class OfferComponent implements OnInit {
  offer;
  offerUid: string;
  editState: boolean;
  itemToEdit: any;
  projUid: string;
  proj;
  modules: any[];
  galleryType: any[] = [];
  pageWithLinkIds: any[] = [];
  flag: boolean = false;
  editState1: boolean;
  itemToEdit1: any;
  showCopyNote: boolean = false;
  showPhone: boolean = false;
  showPhoneNumber: boolean = false;
  phoneNumber: number;
  routeNavigate: any;
  hesh: string;
  moduleName: string;
  currentItem: number;
  showSubMenu: boolean = false;
  doc: Element;
  projTitle: any;
  titleOffer: any;
  counter: number;
  ipAddress = '';
  compId: string;

  constructor(private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    public googleAnalyticsService: GoogleAnalyticsService,
    private http: HttpClient) {
    this.compId = this.route.snapshot.paramMap.get('id');
    this.offerUid = this.route.snapshot.paramMap.get('offerUid');
    this.projUid = this.route.snapshot.paramMap.get('idp');
  }

  ngOnInit(): void {
    this.getIPAddress();
    this.doc = document.getElementsByTagName("app-offer")[0];
    this.hesh = randomString(15);
    // this.routeNavigate = location.hostname + this.router.url;
    this.routeNavigate = 'https://spirical.net' + this.router.url;
    this.dataService.getSpecProject(this.projUid).subscribe(proj => {
      this.proj = proj;
      this.modules = this.proj.modules;
      this.switchModules(this.modules);
      console.log(this.proj);
      console.log(this.modules);
      this.projTitle = this.proj.title;
    })
    this.dataService.getSpecialOffer(this.offerUid).subscribe(offer => {
      this.offer = offer[0];
      this.itemToEdit = this.offer.flatsArray[0];
      this.editState = true;
      this.userOnline();
      this.titleOffer = this.offer.title;
      this.titleService.setTitle('spirical' + '-' + this.titleOffer + '-' + this.projTitle);
      // if(this.counter !== 1){
      //   this.counter = 0;
      // }
      // if(this.counter === 0){
      //   this.loadScript();
      //   this.counter = 1;
      // }
    })
    this.dataService.getPagesWithLink(this.projUid).subscribe(items => {
      this.pageWithLinkIds = items;
      console.log("pages-with-linksN", this.pageWithLinkIds);
    });
  }

  getIPAddress() {
    this.http.get("http://api.ipify.org/?format=json").subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  loadScript() {
    let node = document.createElement('script'); // creates the script tag
    // node.src = 'dfsfsf'; // sets the source (insert url in between quotes)
    // node.type = 'text/javascript'; // set the script type
    // node.async = true; // makes script run asynchronously
    // node.charset = 'utf-8';
    node.text = "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', 'G-R7Y0EQJ5KM');"
    // append to head of document
    document.getElementsByTagName('head')[0].appendChild(node);
  }
  shareGalleryF(type) {
    // item.shareflatgallery = !item.shareflatgallery;
    if (!this.offer.shareGalleries) {
      this.offer.shareGalleries = [];
      this.offer.shareGalleries.push(type);
    } else {
      if (!this.offer.shareGalleries.includes(type)) {
        this.offer.shareGalleries.push(type);
      }
    }
    this.dataService.updateItem(this.offer, 'offers/')
  }
  userOnline() {
    if (this.offer.connect) {
      if (this.offer.connect.date + 3000 < Date.now()) {
        this.offer.connect.now = true;
        this.offer.connect.date = Date.now();
        this.dataService.updateItem(this.offer, 'offers/');
      }
    } else {
      this.offer.connect = {};
      this.offer.connect.now = 'yes';
      this.offer.connect.date = Date.now();
      this.dataService.updateItem(this.offer, 'offers/');
    }
  }
  ngOnDestroy() {
    this.offer.connect.now = false;
    this.offer.connect.date = Date.now();
    this.dataService.updateItem(this.offer, 'offers/');
  }

  shareDynamicGalleryF(page) {
    // item.shareflatgallery = !item.shareflatgallery;
    if (!this.offer.shareDynamicGallery) {
      this.offer.shareDynamicGallery = [];
      this.offer.shareDynamicGallery.push(page);
    } else {
      let ifContains = false;
      this.offer.shareDynamicGallery.forEach(gallery => { if (gallery.id === page.id) { ifContains = true; } })
      if (!ifContains) {
        this.offer.shareDynamicGallery.push(page);
      }
    }
    this.dataService.updateItem(this.offer, 'offers/')
  }

  switchModules(modules) {
    if (modules) {
      for (let i = 0; modules.length > i; i++) {
        const moduleNameTrigger = modules[i];
        // this.modulesArray[0][moduleNameTrigger.moduleName] = true;
        switch (moduleNameTrigger.moduleName) {
          case 'video':
            this.galleryType.push("progVideo");
            break;
          case 'pdf':
            this.galleryType.push("progPDF");
            break;
          case 'simulators':
            this.galleryType.push("progImages");
            break;
          case 'simple':
            this.galleryType.push("simpleImage");
            break;
          case 'simple1':
            this.galleryType.push("simpleImage1");
            break;
          case 'simple2':
            this.galleryType.push("simpleImage2");
            break;
          case 'simple3':
            this.galleryType.push("simpleImage3");
            break;
          default:
        }
      }
    }
  };

  modulesGetTitle(module) {
    if (module) {
      // this.modulesArray[0][moduleNameTrigger.moduleName] = true;
      switch (module) {
        case 'progVideo':
          this.galleryType.push("progVideo");
          this.moduleName = 'video';
          return this.moduleToTitle(this.moduleName);
          break;
        case 'progPDF':
          this.galleryType.push("progPDF");
          this.moduleName = 'pdf';
          return this.moduleToTitle(this.moduleName);
          // return'pdf';
          break;
        case 'progImages':
          this.galleryType.push("progImages");
          this.moduleName = 'simulators';
          return this.moduleToTitle(this.moduleName);
          break;
        case 'simpleImage':
          this.galleryType.push("simpleImage");
          this.moduleName = 'simple';
          return this.moduleToTitle(this.moduleName);
          break;
        case 'simpleImage1':
          this.galleryType.push("simpleImage1");
          this.moduleName = 'simple1';
          return this.moduleToTitle(this.moduleName);
          break;
        case 'simpleImage2':
          this.galleryType.push("simpleImage2");
          this.moduleName = 'simple2';
          return this.moduleToTitle(this.moduleName);
          break;
        case 'simpleImage3':
          this.galleryType.push("simpleImage3");
          this.moduleName = 'simple3';
          return this.moduleToTitle(this.moduleName);
          break;
        default:
      }
    }
  };
  moduleToTitle(moduleName) {
    return this.proj.modules.filter(item => { return item.moduleName === moduleName })[0][moduleName + "Title"];
  }


  removeFlatFromView(currentFlat) {
    const array = []
    if (this.offer.flatsArray && this.offer.flatsArray.length > 0) {
      let indexInclude;
      this.offer.flatsArray.forEach((flat, index) => {
        if (flat.item.id === currentFlat.item.id) {
          indexInclude = index;
          return;
        }
      });
      this.offer.flatsArray.splice(indexInclude, 1);
    }
    this.dataService.updateItem(this.offer, 'offers/')
  }
  removeGalleryF(type) {
    let indexInclude = this.offer.shareGalleries.indexOf(type);
    this.offer.shareGalleries.splice(indexInclude, 1);
    this.dataService.updateItem(this.offer, 'offers/')
  }
  removeDynamicGalleryF(curretPage) {
    let indexInclude;
    this.offer.shareDynamicGallery.forEach((page, index) => {
      if (page.id === curretPage.id) {
        indexInclude = index;
        return;
      }
    });
    this.offer.shareDynamicGallery.splice(indexInclude, 1);
    this.dataService.updateItem(this.offer, 'offers/')
  }
  onSubmit(offer) {
    this.offer.freeText = offer.freeText;
    this.offer.title = offer.title;
    this.dataService.updateItem(this.offer, 'offers/');
    this.clearState();
  }
  clearState() {
    this.editState = false;
    this.itemToEdit = null;
    this.editState1 = false;
    this.itemToEdit1 = null;
  }
  editItem(event, item) {
    this.editState = true;
    this.itemToEdit = item;
    this.currentItem = 0;
    // this.googleAnalyticsService.eventEmitter("offer", "flat-number", this.offer.client.name, item.item.number + "");
    // this.scrollTo(document.getElementById("flat-list"))
  }
  scrollToGal(element) {
    this.currentItem = 0;
    this.scrollTo(document.getElementById(element));
  }
  scrollToStaticGal(element) {
    this.scrollTo(document.getElementById(element));
    this.modulesGetTitle(element);
  }
  scrollTo = (element) => {
    // element = document.getElementById(element);
    // element.scrollIntoView();

    // window.scroll(0, 2200)
    const doc = document.getElementsByTagName("app-offer")[0];
    doc.scroll({
      behavior: 'smooth',
      left: 0,
      top: element.offsetTop
    });

    console.log("dfgdfg");
  }
  editItem1(event, item) {
    this.editState1 = true;
    this.itemToEdit1 = item;
  }
  closeEdit() {
    this.clearState();
  }
  onSubmit2(offer) {
    this.offer.secondFreeText = offer.secondFreeText;
    this.offer.secondTitle = offer.secondTitle;
    this.dataService.updateItem(this.offer, 'offers/');
    this.clearState();
  }
  copyInputMessage(inputElement) {
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.showCopyNote = true;
    let showCopyNote = this.showCopyNote;
    setTimeout(() => {
      this.showCopyNote = false;
    }, 3000);
  }
  showPhoneF() {
    this.showPhone = !this.showPhone;
    if (this.showPhone) {
      this.showPhoneNumber = false;
    }
  }
  openSubMenu($event, currentItem) {
    this.currentItem = currentItem;
    this.showSubMenu = true;
  }
  heshF() {
    console.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&7777777777777777777777777")
    this.hesh = randomString(15);
    let path = this.routeNavigate + '?m=all' + '#' + this.hesh;
    this.router.navigate(['https://api.whatsapp.com/send?&text=' + path]);
  }
}
